/* eslint-disable */ 
import Flickity from 'flickity-fullscreen';

$( window ).on("load", function() {
    Flickity.prototype.dragMove = function (event, pointer, moveVector) {
        if (!this.isDraggable) {
            return;
        }

        event.preventDefault();

        this.previousDragX = this.dragX;
        // reverse if right-to-left
        var direction = this.options.rightToLeft ? -1 : 1;
        if (this.options.wrapAround) {
            // wrap around move. #589
            moveVector.x = moveVector.x % this.slideableWidth;
        }
        var dragX = this.dragStartPosition + moveVector.x * direction;

        //  *** Basically comment out this section to prevent the bounce:
        //
        // if ( !this.options.wrapAround && this.slides.length ) {
        //   // slow drag
        //   var originBound = Math.max( -this.slides[0].target, this.dragStartPosition );
        //   dragX = dragX > originBound ? ( dragX + originBound ) * 0.5 : dragX;
        //   var endBound = Math.min( -this.getLastSlide().target, this.dragStartPosition );
        //   dragX = dragX < endBound ? ( dragX + endBound ) * 0.5 : dragX;
        // }

        this.dragX = dragX;

        this.dragMoveTime = new Date();
        this.dispatchEvent('dragMove', event, [pointer, moveVector]);
    };

    if (document.querySelector('.imageCarousel')) {
        const imageGalleries = document.querySelectorAll('.imageCarousel');

        imageGalleries.forEach((gallery) => {
            new Flickity(gallery, {
                fullscreen: true,
                accessibility: true,
                adaptiveHeight: false,
                groupCells: false,
                initialIndex: 0,
                imagesLoaded: true,
                lazyLoad: 2,
                percentPosition: true,
                prevNextButtons: true,
                pageDots: false,
                resize: true,
                rightToLeft: false,
                setGallerySize: false,
                watchCSS: false,
                wrapAround: false,
                cellAlign: 'left',
                contain: true,
                selectedAttraction: 0.01,
                friction: 0.15,
            });
        });
    }

    if (document.querySelector('.entryCarousel')) {
        const entryGalleries = document.querySelectorAll('.entryCarousel');

        entryGalleries.forEach((gallery) => {
            new Flickity(gallery, {
                accessibility: true,
                adaptiveHeight: false,
                groupCells: false,
                initialIndex: 0,
                imagesLoaded: true,
                lazyLoad: true,
                percentPosition: true,
                prevNextButtons: true,
                pageDots: false,
                resize: true,
                rightToLeft: false,
                setGallerySize: false,
                watchCSS: false,
                wrapAround: false,
                cellAlign: 'left',
                contain: true,
                selectedAttraction: 0.01,
                friction: 0.15,
            });
        });
    }

    if (document.querySelector('.carousel-fullscreen')) {
        const slideGalleries = document.querySelectorAll(
            '.carousel-fullscreen'
        );
        slideGalleries.forEach((gallery) => {
            new Flickity(gallery, {
                fullscreen: true,
                pageDots: true,
                imagesLoaded: true,
                lazyLoad: true,
                wrapAround:false,
                fade: true,
            });
        });
    }

    // CAPTIONS for slider?
    /*
var $carousel = $('.carousel-fullscreen').flickity({
    cellSelector: 'img',
});



var 
var $caption = $('.caption');
// Flickity instance
var flkty = $carousel.data('flickity');

$carousel.on('select.flickity', function () {
    // set image caption using img's alt
    $caption.text(flkty.selectedElement.alt);
});
*/

    /**
     * Flickity accessibility patch. Adds aria-hidden to slides which are outside the horizontal viewport.
     *
     * Adapted from https://gist.github.com/neodigm/bf64202df7ff854c910977eb1f2515a0
     */
    class FlickPatch {
        //  Flick Carousel ARIA-HIDDEN observer
        constructor(document, selector) {
            this.document = document;
            this.selector = selector;
            this.sliders = [];
        }
        init() {
            this.sliders = Array.from(
                this.document.querySelectorAll(this.selector)
            );
            if (this.sliders.length) {
                this.sliders.forEach((slider) => {
                    const mutationObserver = new MutationObserver(() => {
                        if (
                            flickPatch &&
                            typeof flickPatch.removeAttr === 'function'
                        ) {
                            flickPatch.removeAttr(slider);
                        }
                    });
                    mutationObserver.observe(slider, {
                        attributes: true,
                        childList: true,
                        subtree: true,
                    });
                    this.removeAttr(slider);
                });
            }
            return this;
        }
        removeAttr(slider) {
            const threshold = 0.1;
            if (slider) {
                [...slider.querySelectorAll('.carousel__slide')].forEach(
                    (slide) => {
                        var rect = slide.getBoundingClientRect();
                        const overlap = rect.width * threshold;
                        var viewWidth = Math.max(
                            document.documentElement.clientWidth,
                            window.innerWidth
                        );
                        if (
                            !(
                                rect.right < 0 + overlap ||
                                rect.left >= viewWidth - overlap
                            )
                        ) {
                            if (slide.getAttribute('aria-hidden')) {
                                slide.removeAttribute('aria-hidden');
                            }
                        } else {
                            if (!slide.getAttribute('aria-hidden')) {
                                slide.setAttribute('aria-hidden', 'true');
                            }
                        }
                    }
                );
            }
        }
    }
    //. Usage
    let flickPatch = {};
    document.addEventListener('DOMContentLoaded', (ev) => {
        flickPatch = new FlickPatch(document, '.entryCarousel');
        flickPatch.init();
    });
});



    /* eslint-enable */

    